import { render, staticRenderFns } from "./carAdsList.vue?vue&type=template&id=60eda86a"
import script from "./carAdsList.vue?vue&type=script&lang=js"
export * from "./carAdsList.vue?vue&type=script&lang=js"
import style0 from "./carAdsList.vue?vue&type=style&index=0&id=60eda86a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports